import React from "react"

import New from "./New"
import Table from "./Table"

const TutorApplicationInterviewersIndex = () => {
  return (
    <>
      <New />
      <Table />
    </>
  )
}

export default TutorApplicationInterviewersIndex
